import { render, staticRenderFns } from "./ro-navegator.vue?vue&type=template&id=4fbd59ca&"
import script from "./ro-navegator.vue?vue&type=script&lang=js&"
export * from "./ro-navegator.vue?vue&type=script&lang=js&"
import style0 from "./ro-navegator.vue?vue&type=style&index=0&id=4fbd59ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports